import { IconifyIcon } from 'iconify-icon'

export const IconPlay: IconifyIcon = {
	'body': '<svg xmlns="http://www.w3.org/2000/svg" width="42" height="48.5" viewBox="0 0 42 48.5"><path fill="currentColor" d="M42,25,0,49.25V.75Z"/></svg>',
	'width': 42,
	'height': 48.5,
}
export default IconPlay
